// src/hooks/useHideSideMenu.js
export const useHideSideMenu = (path) => {
    // Add patterns here for routes where you want to hide the side menu
    const hidePatterns = [
      /^\/blog\/.+/,  // Matches /blog/:blog_key
      /^\/blog\/archives$/,  // Matches /blog/archives exactly
      // Add more patterns as needed
      /^\/links$/,  // Matches /links exactly
      /^\/page\/.+/,  // Matches /page/:blog_key
      /^\/laddu/,  // Matches /laddu and /laddu/:letter_slug
      /^\/health/,  // Matches /health and all sub-routes
      /^\/ai/,  // Matches /ai and all sub-routes
      /^\/notes/,  // Matches /notes and all sub-routes
    ];
  
    return hidePatterns.some(pattern => pattern.test(path));
  };